import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'; // Import axios for making HTTP requests
import './Login.css';
import { brand } from '../branding';

const Login = ({ setIsLoggedIn, setUsername, setFirstName, setLastName, setRole }) => {
    const [username, setEnteredUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL || "https://ns-dashboard-api.kabilah.com"}/login`, {
                username,
                password
            });

            if (response.data.success) {
                // Login successful
                localStorage.setItem('isLoggedIn', 'true');
                localStorage.setItem('username', response.data.username); // Save the username
                // Only admins get a real name back — students log in with numbered
                // usernames and firstName/lastName come back null for them.
                if (response.data.firstName) {
                    localStorage.setItem('firstName', response.data.firstName);
                } else {
                    localStorage.removeItem('firstName');
                }
                if (response.data.lastName) {
                    localStorage.setItem('lastName', response.data.lastName);
                } else {
                    localStorage.removeItem('lastName');
                }
                localStorage.setItem('role', response.data.role || '');
                setIsLoggedIn(true); // Update the state in App.js
                setUsername(response.data.username); // Store the username in the App state
                setFirstName(response.data.firstName || '');
                setLastName(response.data.lastName || '');
                setRole(response.data.role || '');
                navigate('/'); // Redirect to home after login
            }
        } catch (error) {
            // Handle errors such as 401 Unauthorized
            setError('Invalid username or password');
        }
    };

    return (
        <div className="login-container">
            <form onSubmit={handleLogin} className="login-form">
                <img src={brand.loginLogo} alt={`${brand.name} Logo`} className="login-logo" />
                <h2 className="login-title">{brand.name}</h2>
                <input
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setEnteredUsername(e.target.value)}
                    className="login-input"
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="login-input"
                />
                {error && <p className="login-error">{error}</p>}
                <button type="submit" className="login-button">
                    Login
                </button>
            </form>
        </div>
    );
};

export default Login;